function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { uuid } from 'uuidv4';

var RiderEntry = function RiderEntry(props) {
  _classCallCheck(this, RiderEntry);

  this.id = uuid();
  this.rider = {};
  this.ageGroup = undefined;
  this.motos = [];
  this.notes = '';
  this.photos = [];

  _extends(this, props);
};

export default RiderEntry;